(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auffa-results-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('auffa-timeline')) {
    class AuffaTimeline extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('.auffa-tl__rail');
        this.fill = this.querySelector('.auffa-tl__rail-fill');
        this.steps = Array.from(this.querySelectorAll('.auffa-tl__step'));
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.editor = window.Shopify && window.Shopify.designMode;
        this.animate = this.hasAttribute('data-animate') && !this.reduced && !this.editor;

        if (this.animate) {
          this.classList.add('is-animated');
          this.io = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  entry.target.classList.add('is-visible');
                  this.io.unobserve(entry.target);
                }
              });
            },
            { rootMargin: '0px 0px -15% 0px', threshold: 0.15 }
          );
          this.steps.forEach((step) => this.io.observe(step));
        } else {
          this.steps.forEach((step) => step.classList.add('is-visible'));
        }

        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.ticking = false;
            this.update();
          });
        };
        this.onResize = () => {
          this.measure();
          this.update();
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.onResize);
          this.ro.observe(this);
        }
        this.measure();
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        if (this.io) this.io.disconnect();
        if (this.ro) this.ro.disconnect();
      }

      measure() {
        const dots = this.querySelectorAll('.auffa-tl__dot');
        if (!dots.length) return;
        const box = this.getBoundingClientRect();
        const first = dots[0].getBoundingClientRect();
        const last = dots[dots.length - 1].getBoundingClientRect();
        const top = first.top + first.height / 2 - box.top;
        const height = last.top + last.height / 2 - box.top - top;
        this.style.setProperty('--tl-rail-top', top + 'px');
        this.style.setProperty('--tl-rail-height', Math.max(height, 0) + 'px');
        this.dotOffsets = Array.from(dots).map((dot) => {
          const r = dot.getBoundingClientRect();
          return r.top + r.height / 2 - box.top;
        });
        this.railTop = top;
        this.railHeight = Math.max(height, 0);
      }

      update() {
        if (!this.dotOffsets) return;
        if (!this.animate) {
          this.fill.style.transform = 'scaleY(1)';
          this.steps.forEach((step) => step.classList.add('is-reached'));
          return;
        }
        const atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
        const anchor = atBottom ? Infinity : window.innerHeight * 0.6 - this.getBoundingClientRect().top;
        const progress = this.railHeight ? Math.min(Math.max((anchor - this.railTop) / this.railHeight, 0), 1) : 1;
        this.fill.style.transform = 'scaleY(' + progress + ')';
        this.steps.forEach((step, i) => step.classList.toggle('is-reached', anchor >= this.dotOffsets[i] - 1));
      }
    }
    customElements.define('auffa-timeline', AuffaTimeline);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
